/* Add default Photo  June 15, 2025 */
/* Amend for GUI Changes Phase 1 Apr 24, 2026 */
/* Amend to disable save if no p_recInfo.Id May 9, 2026 */
<template lang="pug">
div(class="kt-modal-photo" :id="this.p_prntRecKey+'.ktModalPhoto'")
	div(class="kt-photo")
		div(class="kt-photo-toolbar")
			b-button(:disabled="!p_recInfo.Id" class="btn-upload" title="Upload/Edit" variant="outline-secondary" @click="m_uploadFilesClick")
				fa-icon(icon="pencil-alt")
			b-button(:disabled="c_btnSaveDisabled" class="btn-camera-save" title="Save photo" variant="outline-secondary" @click="m_savePhotoClick")
				fa-icon(icon="save")
			b-button(class="btn-expand"  variant="outline-secondary" title="Full screen" @click="m_fullScreenClick")
				fa-icon(icon="expand-alt" id="expandIcon")
			b-button(:disabled="!p_photoRec.photoURL" class="btn-delete" title="Delete/Cancel" variant="outline-secondary" @click="m_deletePhoto")
				fa-icon(icon="trash-alt")
		div(@click="m_uploadFilesClick")
			//img(v-if="!p_photoRec.photoURL" id="appPhoto"  src="@/assets/SitePlaceHolder.jpg" class="imgHeader")
			//img(v-else id="appPhoto"  :src="p_photoRec.photoURL" class="imgHeader")
			img(:disabled="!p_recInfo.Id" :id="p_prntRecKey+'.appPhoto'"  :src="c_photoURL" :class="{'team': p_prntRecKey == 'team','contact': p_prntRecKey == 'extr'}")
		div(class="kt-photo")
			//- Loading
			kt-spinner(v-if="d_loading" p_txt="d_loadingText")
			input(hidden class="btn-upload" :ref="p_prntRecKey+'.file-upload'" :id="p_prntRecKey+'.file-upload'" type="file" accept="image/png, image/gif, image/jpeg"  @change="m_fileUploadChange")
			//- Dragbox
			div(:id="p_prntRecKey+'.dragbox'" @dragover="m_dragover" @dragleave="m_dragleave" @drop="m_drop" :class="d_inDrag?'dragover':null")
		
</template>
<script>
import util, {kbdpAlert} from "@/utils/util.js";
import {api_baseURL} from "@/utils/init.js";
import {fn_appEnt} from "@/utils/ref-data.js";
import {photos as api} from "@/utils/api.js";
import sitePlaceHolder from "@/assets/SitePlaceHolder.jpg";
import imgOppr from "@/assets/SitePlaceHolder.jpg";
import imgAcct from "@/assets/defaultAccountImage.png";
import imgPerson from "@/assets/defaultPersonImage.png";
export default {
	name: "kt-photo",
	components: {
	},
	created() {},
	mounted() {this.m_getPhotos;},
	data() {
		return {
			d_prntAppEnt: fn_appEnt(this.p_prntRecKey),
			d_rootNode: {},
			d_loading: null,
			d_loadingText: null,
			d_inDrag: null,
			d_baseURL: api_baseURL,
			d_photoSrc: null,
			d_photoURL: this.p_photoRec.photoURL,
			d_blobURL: URL.createObjectURL(new Blob([JSON.stringify(this.p_photoRec.photoURL,null, 2)])),
			d_files: null,
			d_uploadFile: false,
			d_showPhoto:false,
			d_photos:null,
			d_currentPhoto:0,

		};
	},
	props: {
		p_prntRecKey: String, //==> oppr, proj, acct,cmpt,extr,team
		p_recInfo: Object,
		p_photoRec: Object,
	},
	computed: {
		c_btnSaveDisabled(){return !(this.d_uploadFile&&this.p_recInfo.Id);},
		c_photos() {return this.d_photos;},
		c_multiPhotos() {return this.d_photos.length>1;},
		c_noPhotos(){return !this.d_photos;},
		c_photoURL() {
			const defaultImages = {
				oppr: imgOppr,
				proj: imgOppr,
				acct: imgAcct,
				extr: imgPerson,
				team: imgPerson,
				cmpt: imgAcct,
			};

      return this.p_photoRec.photoURL ? this.p_photoRec.photoURL: defaultImages[this.p_prntRecKey];
	},
	},
	methods: {
		
		m_savePhotoClick(){

			var photoParams={photoId: this.p_photoRec.photoId?this.p_photoRec.photoId:null,
							photoName:this.d_files.name.substring(this.d_files.name.lastIndexOf('.'), 0).substring(0, 100),
							photoURL: this.d_photoURL,
							recordContext: this.d_prntAppEnt.idKey,
							recordId: this.p_recInfo.Id,
							recordNo: this.p_recInfo.No,
							removed: null
							};
		api.fn_savePhoto(photoParams).then(resp => {
		if (resp.error || !resp.upsRecHdr) {
			let msg = `Unable to process requested change. ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		this.d_photoId=resp.upsRecHdr.photoId;
		this.p_photoRec.photoId=resp.upsRecHdr.photoId;
		this.p_photoRec.photoName=resp.upsRecHdr.photoName;
		this.p_photoRec.photoURL=this.d_photoURL;
		let msg = `The photo ${photoParams.photoName} was saved successfully`;
		kbdpAlert.showOk(msg);
		
		});
		
		},
		
		m_deletePhoto(){
		
		let content = {
				titleText: 'Confirm Delete Photo',
				message1: 'Are you sure you want to remove this photograph"?',
			};
			let cm = util.fn_getModal_confirm(this, content);
			cm.opt.okTitle += ', Delete';
			cm.opt.cancelTitle += ', Keep';
			this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
			if (!resp) return;
			const projectPhoto = document.getElementById(this.p_prntRecKey+'.appPhoto');
			projectPhoto.src  = null;
			this.d_uploadFile=false;
				})
			
			if(this.p_photoRec.photoId){
				var photoParams={photoId: this.p_photoRec.photoId,
								photoName:this.p_photoRec.photoName,
								photoURL: this.p_photoRec.photoURL,
								recordContext: this.d_prntAppEnt.idKey,
								recordId: this.p_recInfo.Id,
								recordNo: this.p_recInfo.No,
								removed: true
								};
		api.fn_savePhoto(photoParams).then(resp => {
		if (resp.error || !resp.upsRecHdr) {
			let msg = `Unable to process requested change. ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		let msg = `The photo ${photoParams.photoName} was deleted successfully `;
		kbdpAlert.showErr(msg);
		});
		
		}
		this.p_photoRec.photoId=null;
		this.d_photoURL=null;
		this.p_photoRec.photoURL=null;
	},
		
		m_fullScreenClick(){
		var projectPhoto = document.getElementById(this.p_prntRecKey+'.appPhoto');
		projectPhoto.requestFullscreen({ navigationUI: "hide" }).then(() => {}).catch(err => {
		alert(`An error occurred while trying to switch into full-screen mode: ${err.message} (${err.name})`);
		});
		
		},
		m_uploadFilesClick() {

			let uploadFile = this.$refs[this.p_prntRecKey+'.file-upload'];
			//let uploadFile=document.getElementById(this.p_prntRecKey+'.file-upload');
			uploadFile.value = null;
			uploadFile.click();
			
		},
		m_fileUploadChange(e) {

			var _this=this;
							
			this.d_cameraClicked=false;
			this.d_uploadFile=true;
			const photo = document.getElementById(this.p_prntRecKey+'.appPhoto');
			var photoFile=e.target.files[0];
			this.d_blobURL=URL.createObjectURL(photoFile);
			this.d_files=photoFile;
			
			
			const reader = new FileReader();
			
			let fileURL;
			reader.addEventListener("load", function () {
		// convert image file to base64 string
			photo.src=reader.result;
			fileURL=reader.result;
			_this.m_fileUploadHandler(fileURL);
			
			}, false);

			if (photoFile) {
			reader.readAsDataURL(photoFile);
			}
			
			
			var photoFiles=[];
			photoFiles.push(photoFile);  // Make an Array.
			
					
					
				
	},
		m_dragover(e) {
			e.preventDefault();
			this.d_inDrag = true;
		},
		m_dragleave(e) {
			e.preventDefault();
			let isdb = e.target.id == this.p_prntRecKey+'.dragbox';
			if (isdb) {
				this.d_inDrag = null;
			}
		},
		m_drop(e) {
			e.preventDefault();
			this.d_inDrag = null;
			var vFiles=[];
			var vFile={};
			var files=e.dataTransfer.files;	
			for (var x = 0; x < files.length; x++)
					{vFile=files[x];	
					vFiles.push(vFile);
					}
			this.d_files=vFiles;
			//fn_savPhoto(photoParamas)
		},
		m_fileUploadHandler(fileURL){
			this.d_photoURL=fileURL;
			
		}
	},
	
	watch: {},
}
</script>

<style scoped lang="less">
.kt-photo {
	//border: solid 0.1em #e9ecef;
	//border-radius: 0.25rem;
	border:none;
	//padding: 0 0.1em 0.5em 0.1em;

	.form-group {
		margin-bottom: 0em;
		padding: 0 1em;
		label {
			font-size: 0.8em;
		}
	}
	div#dragbox.dragover {
			border: dashed 0.2em #4fa4ff;
			background-color: #dee2e6;
			opacity: 0.5;

			div.note {
				color: #4fa4ff;
				svg.fa-upload {
					opacity: unset;
				}
			}
			> div {
				pointer-events: none;
				//Importat, Prevents drag leave when hovring inside dragboxx
			}
		}
	div.note {
			position: relative;
			padding: 1em 0;
			text-align: center;

			> span:first-child {
				padding: 1em 0;
			}
			> div {
				> svg.fa-upload {
					font-size: 1.5em;
					opacity: 0.5;
				}
				> span {
					display: block;
				}
			}
		}
.btn-delete {
	color: #dc3545;
	text-align: right;
	border:none;
	}
.btn-upload {
	color: #4fa4ff;
	border:none;
	}
.btn-expand {
	color: #FFA500;
	border:none;
	}
.btn-compress {
	color: #FFA500;
	}
.btn-camera {
	color: #4fa4ff;
	border:none;
	}
.btn-camera-clicked {
	color: #008000;
	}
.btn-camera-black {
	color: #000000;
	}
.btn-camera-save {
	color: #008000;
	border:none;
	}
}
.kt-modal-photo {
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}
/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}
/* Caption of Modal Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}
/* Add Animation */
.modal-content, #caption {  
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {-webkit-transform:scale(0)} 
  to {-webkit-transform:scale(1)}
}

@keyframes zoom {
  from {transform:scale(0)} 
  to {transform:scale(1)}
}
/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}
.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}
/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
}
}
img {width: 200px !important;
	height:125px !important;
	border-radius:8px !important;
}
img.team {
  width: 150px !important;
  height: 150px !important;
  border-radius: 50% !important;
  object-fit: cover;
}
img.contact {
  width: 150px !important;
  height: 150px !important;
  border-radius: 50% !important;
  object-fit: cover;
}
</style>